import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { AppState, TypedDispatch } from 'redux/store';

export const useAppDispatch: () => TypedDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
